import React, { Component } from 'react';
import { WithStyles, createStyles, Typography, Grid, TextField, Table, TableRow, TableCell, TableHead, Button, Select, FormControl, TableBody, Tooltip, IconButton, Switch, FormControlLabel } from '@material-ui/core';
import { withStyles, Theme } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import { CloseOutlined as CloseIcon, Error } from '@material-ui/icons';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import MyPatLocalLoader from '../../../common/MyPATLocalLoader'
import PhaseList from './PhaseList';

import courseManagementServices from '../../service/courseManagementServices';
import { createCoursePlanStatesAction } from '../../reducers/createCoursePlanReducer';
import { showMsg } from '../../../course/actions/loaderAlert';
import moment from 'moment';
import CombinedPhases from '../treeComponents/CombinedPhases';
import { checkTotalChapterDistributed, createCoursePlanPayload, WEEK_FORMAT, dateFormater, checkBetweenDate, mergeGoalsForComboCourse, getCoursePlanById, handleWeekSelect, createSubjectState, checkDateOverlap, manageChapterCount, checkPhaseData, WEEK_FORMAT_LABEL, checkMinimumChapter, checkDuplicatePhaseName, onConfirmChangeWeekFormate, cancelChangeWeekFormate, checkChapterCount, getPhaseStatus } from './helpers/CoursePlanHelper';
import DialogLarge from '../../../content-request/common/DialogLarge';
import { createDeepCopy, onlyAllowNumbers } from '../../../../utils';
import { createCoursePlanStyles } from '../../styles';
import { contentManagementAction } from '../../reducers/contentMangementData';
import { setGoalsDataForTest, setScheduledTestFetchData } from './helpers/goalsAndTest'
import { getFormatedDate } from '../treeComponents/helper';
import { BonusWarningPopup, SaveAndProceed } from "../PopUp";
import MyPATTruncateText from '../../../common/MyPATTruncateText';
import { ContentPreferences } from '../../types/enums/ContentPreferences';
import { CHANGE_TYPE } from '../../Constants/constants';
import CustomInfoIcon from '../../../common/CustomInfoIcon';
interface CreateCoursePlanContainerProps {
  classes: any;
  dispatch: any;
  coursePlanState: any;
  phases: any;
  setPhaseData: Function;
  setCoursePlanStates: Function;
  addedChapterCount: any;
  setchapterCount: Function;
  showMsg: Function;
  handleChangeChecked: Function;
  packageData: any;
  getPackageByIdData: any;
  match: any;
  setCourseSyllabus: Function;
  courseSyllabus: any;
  setChaptersSubject: Function;
  totalSubjectChapters: any;
  setCoursePlanResponse: Function;
  history: any;
  coursePlanResponse: any;
  isGoalCombo?: any;
  setTotalGoalsForComboCourse: Function;
  setScheduledTestData: Function;
  mergedComboCourse: any;
  setCoursePlanDone: Function;
  setCoursePlanValid: Function;
  isTabOpen: boolean,
  setIsTabOpen: Function,
  courseDetailsObject: any;
  setCourseDetailsObject: Function;
  phaseCount: any;
  setPhaseCount: Function;
  handleComponentSwitching: Function;
  treeData: any;
  checkWeek: any;
  setCheckWeek: any;
  phaseAlignmentResponse: any;
  // disabledDatesList: any;
}

interface CoursePlanContainerState {
  phase: any;
  addPhase: boolean;
  subjectHeader: [];
  isClose: boolean;
  phaseData: any;
  checkRevision: boolean;
  totalPhaseToCreate: any;
  isShowCombinedPhase: boolean;
  courseDetailObj: any;
  isRevisionCount: any;
  loading: boolean;
  phaseError: boolean;
  defaultWeekFormat: any;
  displaySettings: any;


}
class CreateCoursePlanContainer extends Component<CreateCoursePlanContainerProps, CoursePlanContainerState> {
  myRef: any
  handleToggle: any;
  phaseUpdateData: any;
  constructor(props: CreateCoursePlanContainerProps) {
    super(props);
    this.state = {
      phase: 1,
      loading: true,
      addPhase: false,
      subjectHeader: [],
      isClose: true,
      phaseData: {},
      checkRevision: false,
      totalPhaseToCreate: 1,
      isShowCombinedPhase: false,
      courseDetailObj: {},
      isRevisionCount: 0,
      phaseError: false,
      defaultWeekFormat: WEEK_FORMAT.MON_TO_SUN,
      displaySettings: {
        showPhases: true,
        showWeeks: true,
        showChapters: true,
        showConcepts: true,
        showTestVisibility: true,
      }

    };
    //@ts-ignore
    this.myRef = React.createRef();
  }

  handleLoadingStatus = () => {
    this.setState({
      loading: false
    })
  }

  componentDidUpdate(prevProps: Readonly<CreateCoursePlanContainerProps>, prevState: Readonly<CoursePlanContainerState>, prevContext: any): void {
    if(prevProps.phases !== this.props.phases) {
      if(this.phaseUpdateData && this.phaseUpdateData.keyName === CHANGE_TYPE.END_DATE) {
        const isActive = getPhaseStatus(
          this.phaseUpdateData.startDate,
          this.phaseUpdateData.endDate
        );
        this.handlePhaseStatus(this.phaseUpdateData.phaseId, {
          currentTarget: { checked: isActive },
        });
        this.phaseUpdateData = null;
      }
    }
  }


  getBulkExamDates = (courseDetails: any) => {
    let ids: any = [];
    const { setCourseDetailsObject } = this.props;
    courseDetails.map(({ courseId }: any) => {
      ids.push(courseId);
    });
    const idsInCommaSeprated = ids && ids.length && ids.join(',');
    courseManagementServices.getBulkExamDates(idsInCommaSeprated).then((res: any) => {
      if (res && res.responseObject) {
        const { responseObject: { goals = [] } = {} } = res;
        if (goals && goals.length) {
          setCourseDetailsObject({ courseDetailsObject: [...goals] })
        }
      }
    });
  }

  componentDidMount = async () => {

    const { setCoursePlanStates, setCourseSyllabus, totalSubjectChapters, setChaptersSubject, setCoursePlanResponse, setCourseDetailsObject, coursePlanResponse, handleComponentSwitching } = this.props;
    const { match: { params: { id = '' }, }, coursePlanState, } = this.props;


    await courseManagementServices.getPackageById(id).then((response: any) => {
      const { responseObject = {} } = response;
      const { packageData = {} } = responseObject;
      const { courseDetails = [], type = '', startDate = '', expiryDate = '', coursePlanId = '', includedPackages = [] } = packageData;
      let coursePlanData: any = {
        startDate,
        endDate: expiryDate,
        packageId: id,
        weekFormat: WEEK_FORMAT.MON_TO_SUN
      };

      if (courseDetails && courseDetails.length > 1 || (type === 'combo' && includedPackages && includedPackages.length)) {
        let courseId = courseDetails[0].courseId;
        if (coursePlanId !== null) {
          if (Object.keys(this.props.mergedComboCourse).length || Object.keys(this.props.treeData).length)
            this.handleLoadingStatus();
          if (!this.props.isTabOpen) {
            getCoursePlanById(coursePlanId, setCoursePlanResponse, this.handleLoadingStatus);
          }
          else {
            setCoursePlanResponse({
              coursePlanResponse: JSON.parse(JSON.stringify(this.props.treeData))
            })
          }
          this.setState({ isShowCombinedPhase: true }, () => console.log(this.state.isShowCombinedPhase, ':::::showPhase::::::'));
        } else {

          mergeGoalsForComboCourse(this.props, response).then((resultData) => {
            // courseManagementServices.getCourseDetails(courseId).then((res) => {
            //   // this.setState({ courseDetailObj: res });
            //   setCourseDetailsObject({ courseDetailsObject: { ...res } })
            // });
            this.getBulkExamDates(courseDetails);
            if (resultData.length > 0) {
              coursePlanData.subjects = resultData;
              coursePlanData.type = 'combo';
            }

            setCoursePlanStates({ coursePlanState: { ...coursePlanState, ...coursePlanData } });
            this.generatePhase();
            this.handleLoadingStatus();
            this.myRef.current.value = 1;
            this.props.setPhaseCount({ phaseCount: 1 });
          });
        }

      } else {
        this.handleLoadingStatus();
        //console.log(':::::::::::::::::::::tssting::::::::::::::::::');
        if (!this.props.isTabOpen) {
          this.myRef.current.value = 1;
          this.props.setPhaseCount({ phaseCount: 1 });
          let courseId = courseDetails[0].courseId;
          courseManagementServices.getCourseSyllabus(courseId).then((res) => {
            let syllabusResult = res;
            setCourseSyllabus({ courseSyllabus: [...syllabusResult] });

            let subjects = syllabusResult.filter(
              (syllabusData: any) => syllabusData.type === 'subject'
            );

            let subjectArr: any = [];
            let subjectChaptersArr: any = [];
            subjects.forEach((subject: any) => {
              let chapters = syllabusResult.filter(
                (syllabusData: any) =>
                  syllabusData.type === 'chapter' && syllabusData.ancestors.includes(subject._id)
              );
              subjectArr.push({ id: subject.masterIDs[0], name: subject.name, chapterCount: chapters.length, });
              subjectChaptersArr.push({ id: subject.masterIDs[0], _id: subject._id, courseId: subject.courseId, name: subject.name, chapterCount: chapters.length, chaptersData: chapters });
            });
            this.getBulkExamDates(courseDetails);
            if (subjectArr.length > 0) {
              coursePlanData.subjects = subjectArr;
              coursePlanData.type = 'standard';
            }

            setCoursePlanStates({ coursePlanState: { ...coursePlanState, ...coursePlanData } });
            setChaptersSubject({
              totalSubjectChapters: [...totalSubjectChapters, ...subjectChaptersArr],
            });
            this.generatePhase();
          });
        }
      }
    });
    this.props.setIsTabOpen({ booleanValue: true });
    // else if(coursePlanResponse && coursePlanResponse._id){
    //    handleComponentSwitching('Selected');
    // }
  };

  componentWillReceiveProps = () => {

    // if(this.props.totalSubjectChapters > 0){
    // this.forceUpdate();
    // }

  }

  generateHeader(subjects: any) {
    const { classes } = this.props;
    let res: any = [];

    if (subjects.length) {
      subjects.forEach((subject: any) =>
        res.push(
          <Tooltip title={subject.name}
            PopperProps={{
              popperOptions: {
                modifiers: {
                  offset: {
                    enabled: true,
                    offset: '-10px, -15px',
                  },
                },
              }
            }}
          >
            <TableCell className={classes.testLabel} style={{ maxWidth: '50px', padding: '4px' }}>
              <>
                <div style={{ textAlign: 'center' }} className={classes.testLabel} key={subject.name.substring(0, 2).toUpperCase()}>{`${subject.name
                  .substring(0, 2)
                  .toUpperCase()}`}</div>
                <div style={{ textAlign: 'center' }} className={classes.testLabel}>
                  {`(${subject.chapterCount})`}
                </div>
              </>
            </TableCell>
          </Tooltip>

        )
      );
      return res;
    }
  }

  managePhaseState = (PhaseCount: number) => {
    const { coursePlanState = {}, setPhaseData, phases } = this.props;
    const { subjects = [], totalPhase = 1, weekFormat = '' } = coursePlanState;

    let subjectStateObj = createSubjectState(subjects);
    const newPhase = {
      id: PhaseCount,
      phaseName: '',
      subject: subjectStateObj,
      startDate: '',
      endDate: '',
      isRevision: false,
    };

    setPhaseData({ phases: { ...phases, [`phase${PhaseCount}`]: newPhase } });
  };

  handlePhaseData = (event: any) => {
    const { phases } = this.props;
    let count: any = Object.keys(phases).length;
    if (Number(event.target.value) < count) {
      this.setState({ phaseError: true });
      // this.props.showMsg('Phase(s) cannot decrease', 'error');
      return false;
    } else {
      this.setState({ totalPhaseToCreate: Number(event.target.value) >= 1 ? Number(event.target.value) : 1 }, () => {
        this.generatePhaseData();
        this.props.setPhaseCount({ phaseCount: this.state.totalPhaseToCreate })
      })
      this.setState({ phaseError: false });
    }

  };

  handlePhasecount = (event: any) => {
    this.setState({ totalPhaseToCreate: Number(event.target.value) >= 1 ? Number(event.target.value) : 1 }, () => {
      let count: any = this.state.totalPhaseToCreate;
      this.props.setPhaseCount({ phaseCount: this.state.totalPhaseToCreate })
      this.generatePhase();

    });
    // if (event.target.value >= 1) {
    //   this.setState({ totalPhaseToCreate: Number(event.target.value) }, () => {
    //     this.generatePhase();
    //   });
    // }
  };

  generatePhaseData = () => {
    const { coursePlanState = {}, setPhaseData, setchapterCount, phases } = this.props;
    const { subjects = [], totalPhases = 1, weekFormat = '' } = coursePlanState;
    const { totalPhaseToCreate } = this.state;

    let subjectStateObj = createSubjectState(subjects);
    let phaseLen = Object.keys(phases).length + 1;

    let phaseArr: any = [];

    while (phaseLen <= totalPhaseToCreate) {
      const initialPhase = {
        id: phaseLen,
        phaseName: '',
        subject: subjectStateObj,
        startDate: '',
        endDate: '',
        isRevision: false,
      };
      phaseArr[`phase${phaseLen}`] = { ...initialPhase };
      phaseLen++;

    }

    setPhaseData({ phases: { ...phases, ...phaseArr } });

  };

  generatePhase = () => {
    const { coursePlanState = {}, setPhaseData, setchapterCount, phases } = this.props;
    const { subjects = [], totalPhases = 1, weekFormat = '' } = coursePlanState;
    const { totalPhaseToCreate } = this.state;

    let subjectStateObj = createSubjectState(subjects);
    let i = 1;
    const initialPhase = {
      id: 1,
      phaseName: '',
      subject: subjectStateObj,
      startDate: '',
      endDate: '',
      isRevision: false,
    };
    let phaseArr: any = [];
    while (i <= totalPhaseToCreate) {
      phaseArr[`phase${i}`] = { ...initialPhase, id: i };
      i++;
    }
    let addedChapterCount = subjectStateObj;
    setchapterCount({ addedChapterCount: [...addedChapterCount] });
    setPhaseData({ phases: { ...phaseArr } });

  };

  handlePhaseStatus = (phaseId: any, event: any) => {
    const { phases, setPhaseData } = this.props;
    const isActive = event.currentTarget.checked;
    const clonePhases = createDeepCopy(phases);
    const editedPhase = clonePhases[`phase${phaseId}`];
    clonePhases[`phase${phaseId}`] = { ...editedPhase, isActive };
    setPhaseData({ phases: { ...phases, ...clonePhases } });
  }

  handleChangeChecked = (phaseId: any, event: any) => {
    const { coursePlanState = {}, setPhaseData, phases, addedChapterCount, setchapterCount } = this.props;
    const { subjects = [] } = coursePlanState;
    let isCheck: any = event.target.checked;
    let fullOldPhases = { ...phases };
    let oldPhase = fullOldPhases[`phase${phaseId}`];
    const { subject = [] } = oldPhase;
    let oldChapterCount = [...addedChapterCount];

    //subtract chapter count from total count
    Object.entries(subject).forEach((item: any, index: any) => {
      const [key] = Object.entries(item[1]);
      let keyName: any = key[0];
      let value: any = key[1];

      let subjectIndex = oldChapterCount.findIndex((itemData: any) =>
        itemData.hasOwnProperty(keyName)
      );
      oldChapterCount[subjectIndex] = {
        ...oldChapterCount[subjectIndex],
        [keyName]: parseInt(oldChapterCount[subjectIndex][keyName]) - parseInt(value),
      };
    });

    setchapterCount({ addedChapterCount: [...oldChapterCount] });

    let subjectStateObj = createSubjectState(subjects, isCheck);
    let i = 1;
    let initialPhase;
    initialPhase = {
      subject: subjectStateObj,
      isRevision: false,
    };

    let isRevisionCount = 0;
    if (isCheck) {
      initialPhase.isRevision = isCheck;
      isRevisionCount = this.state.isRevisionCount + 1;
    } else {
      isRevisionCount = this.state.isRevisionCount - 1;
    }
    this.setState({ isRevisionCount });
    fullOldPhases[`phase${phaseId}`] = { ...oldPhase, ...initialPhase };
    setPhaseData({ phases: { ...phases, ...fullOldPhases } });
  };

  addNewPhase = () => {
    const { phases } = this.props;
    let phaseLength = Object.keys(phases).length + 1;
    this.setState({ totalPhaseToCreate: phaseLength }, () => {
      this.myRef.current.value = phaseLength;
      this.managePhaseState(phaseLength);
      this.props.setPhaseCount({ phaseCount: this.state.totalPhaseToCreate })
    });
  };

  

  deletePhase = (phaseId: any) => {
    const { coursePlanState = {}, setPhaseData, phases, setchapterCount } = this.props;
    const { subjects = [] } = coursePlanState;
    let oldPhases = { ...phases };

    delete oldPhases[`phase${phaseId}`];
    let subjectStateObj = createSubjectState(subjects);

    let i = 1;
    let phaseArr: any = [];
    let totalChaptersCount: any = createSubjectState(subjects);
    let oldChapterCount = [...totalChaptersCount];
    let isRevisionCount = 0;
    const initialPhase = {
      id: 1,
      phaseName: '',
      subject: subjectStateObj,
      startDate: '',
      endDate: '',
      isRevision: false,
    };
    Object.keys(oldPhases).forEach((item: any) => {
      const { phaseName = '', subject = {}, startDate = '', endDate = '', isRevision = false } = oldPhases[item];
      phaseArr[`phase${i}`] = { id: i, phaseName, subject, startDate, endDate, isRevision };
      if (isRevision) {
        isRevisionCount++;
      }

      Object.entries(subject).forEach((subItem: any, index: any) => {
        const [key] = Object.entries(subItem[1]);
        let keyName: any = key[0];
        let value: any = key[1];

        let subjectIndex = oldChapterCount.findIndex((itemData: any) =>
          itemData.hasOwnProperty(keyName)
        );
        oldChapterCount[subjectIndex] = {
          ...oldChapterCount[subjectIndex],
          [keyName]: parseInt(oldChapterCount[subjectIndex][keyName]) + parseInt(value),
        };
      });

      i++;
    });
    setchapterCount({ addedChapterCount: [...oldChapterCount] });
    this.setState({ totalPhaseToCreate: Object.keys(phaseArr).length, isRevisionCount }, () => {
      this.props.setPhaseCount({ phaseCount: this.state.totalPhaseToCreate });
      this.myRef.current.value = this.state.totalPhaseToCreate;
      setTimeout(() => {
        setPhaseData({ phases: { ...phaseArr } });
      }, 500);
    });
  };

  checkTotalChapterCount = (keyName: any) => {
    checkChapterCount(keyName, this.props);
  }

  handlePhaseChange = (phaseId: number, keyName: any, event: any, isSubject: boolean = false) => {
    const { phases, setPhaseData, setchapterCount, addedChapterCount, coursePlanState, showMsg } = this.props;
    const { startDate = '', endDate = '', weekFormat = '' } = coursePlanState;
    let oldPhase = phases[`phase${phaseId}`];
    let fullOldPhases = { ...phases };
    let str: any = '-';
    if (isSubject) {
      let subjectData = [...oldPhase.subject];
      let subIndex = oldPhase.subject.findIndex((item: any) => item.hasOwnProperty(keyName));
      subjectData[subIndex] = { ...subjectData[subIndex], [keyName]: Number(event.target.value) };
      fullOldPhases[`phase${phaseId}`] = { ...oldPhase, subject: [...subjectData] };
      setPhaseData({ phases: { ...phases, ...fullOldPhases } });

      let oldChapterCount = [...addedChapterCount];
      let subjectIndex = oldChapterCount.findIndex((item: any) => item.hasOwnProperty(keyName));
      oldChapterCount[subjectIndex] = {
        ...oldChapterCount[subjectIndex],
        [keyName]: parseInt(oldChapterCount[subjectIndex][keyName]) + parseInt(event.target.value),
      };

      setchapterCount({ addedChapterCount: [...oldChapterCount] });
      setTimeout(() => {
        manageChapterCount(keyName, this.props);
      }, 500);
    } else {
      let isError = false;
      let selectedDate = "";
      if (keyName === 'startDate' || keyName === 'endDate') {
        selectedDate = moment(event).format("YYYY-MM-DD");
        this.phaseUpdateData = {
          phaseId: phaseId,
          keyName,
          startDate: phases[`phase${phaseId}`].startDate,
          endDate: selectedDate,
        };
        if (checkBetweenDate(selectedDate, startDate, endDate)) {

          if (weekFormat === WEEK_FORMAT.MON_TO_SUN && phaseId > 1) {
            let prePhaseEndDate = fullOldPhases[`phase${phaseId - 1}`].endDate;
            const date = moment(prePhaseEndDate, 'YYYY-MM-DD');
            const prePhWeekDayNum = date.day();

            if (keyName === 'startDate' && prePhWeekDayNum !== 0) {
              let nearestSunday = 7 - prePhWeekDayNum;
              let newEndDate = moment(prePhaseEndDate, 'YYYY-MM-DD')
                .add(nearestSunday, 'days')
                .format('YYYY-MM-DD');

              if (checkBetweenDate(selectedDate, prePhaseEndDate, newEndDate)) {

                showMsg(`The week of this selected date is blocked in previous phase `, 'error');
                isError = true;
              }
            }
          }

          if (keyName === 'endDate' && phases[`phase${phaseId}`].startDate >= selectedDate) {
            showMsg(`End Date should be greater than Start date `, 'error');
            isError = true;
          }
          let isOverlapKey = checkDateOverlap(selectedDate, phaseId, this.props);

          if (isOverlapKey) {
            showMsg(`Date is overlaped with ${phases[isOverlapKey].phaseName} `, 'error');
            isError = true;
          }
        } else {
          showMsg(`Date should be lies between Start date and End date `, 'error');
          isError = true;
        }
      }

      if (keyName === 'phaseName') {

        let checkPhaseName = Object.values(phases).find((phase: any) => phase.phaseName.toLowerCase() === event.target.value.toLowerCase())

        if (typeof checkPhaseName !== 'undefined' && event.target.value != "") {
          //isError = true;
          showMsg(`Phase Name Cannot be same `, 'error');
        }

      }

      if (!isError) {
        let objData = {
          [keyName]: (keyName === "startDate" || keyName === "endDate") ? selectedDate : event.target.value,
        };

        fullOldPhases[`phase${phaseId}`] = { ...oldPhase, ...objData };
        setPhaseData({ phases: { ...phases, ...fullOldPhases } });
      }
    }
  };

  renderPhaseRow = () => {
    const { classes, coursePlanState = {}, phases } = this.props;
    const { subjects = [], weekFormat = '', startDate = '', endDate = '' } = coursePlanState;

    return (
      <>
        {phases &&
          Object.keys(phases).length > 0 &&
          Object.entries(phases).map((phaseData: any) => (
            <PhaseList
              classes={classes}
              handleChangeChecked={this.handleChangeChecked}
              handlePhaseChange={this.handlePhaseChange}
              phaseData={phaseData[1]}
              deletePhase={this.deletePhase}
              subjectHeader={phaseData[1]['subject']}
              checkRevision={this.state.checkRevision}
              startDate={startDate}
              endDate={endDate}
              checkTotalChapterCount={this.checkTotalChapterCount}
              handlePhaseStatus={this.handlePhaseStatus}
            />
          ))}
      </>
    );
  };

  handleClose = () => {
    const { history, match: { params: { id = '' }, path = "" } } = this.props;
    this.setState({ isClose: false });
    this.props.setIsTabOpen({ booleanValue: false });
    this.props.setPhaseCount({ phaseCount: 1 });
    if (path === "/course-Management/create-combo-course/:id/:type?") {
      history.push(`/course-Management/create-combo-course/`);
    } else if (path === "/course-Management/create-standard-course/:id") {
      history.push(`/course-Management/create-standard-course/${id}`);
    }
  };

  returnCombinedPhases = () => {
    //console.log(":::::::::::renderP")
    const { coursePlanResponse, isGoalCombo, match, phaseAlignmentResponse } = this.props;
    const conflictData = match && match.params && match.params.type !== 'Goals' ? !Boolean(match.params.type) ? coursePlanResponse : ((Object.keys(this.props.mergedComboCourse).length > 0) ? this.props.mergedComboCourse : coursePlanResponse) : coursePlanResponse;
    return <CombinedPhases data={conflictData} fromCombo={isGoalCombo} phaseAlignmentResponse={phaseAlignmentResponse} />;
  };



  renderCourseContainer = () => {
    const { classes, coursePlanState = {}, phases, phaseCount, checkWeek } = this.props;
    const { subjects = [], weekFormat = '', startDate = '', endDate = '', totalPhases = 1, } = coursePlanState;
    const { totalPhaseToCreate, isRevisionCount } = this.state;
    let totalChapters = 0;
    subjects.forEach((item: any) => {
      totalChapters += item.chapterCount;
    });
    const courseDurationStart = getFormatedDate(startDate);
    const courseDurationEnd = getFormatedDate(endDate);
    // const checkWeek: any = (e: any) => {checkWeekFormat(e, this.props)};
    //console.log('ddh--', checkWeek)
    return (
      <Grid className={classes.createCoursePlanContainer}>
        <Grid className={classes.createCoursePlanCont}>
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <Typography className={classes.MainHeading} component="h5" variant="h6">
                Create Course Plan
              </Typography>
            </Grid>
            <Grid item className={classes.manageCloseIcon}>
              <IconButton onClick={this.handleClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Grid container alignItems="center">
            <Grid item xs={6}>
              <Typography className={classes.courseDuration} component="subheading" gutterBottom>
                {" "}
                Course Duration: {courseDurationStart.join(" ")} to{" "}
                {courseDurationEnd.join(" ")}
              </Typography>
              <Typography className={classes.countPhase} component="subheading" gutterBottom>
                Total <span className={classes.boldData}>{totalChapters}</span> chapters need to be divided into{" "}
                <span className={classes.boldData}>{phaseCount - isRevisionCount}</span> phase(s)
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Grid container justify="flex-end">
                <Grid item xs={11}>
                  <Grid container justify="center">
                    <Grid item xs={4}>
                      <Typography className={classes.testLabel} component="subheading" gutterBottom>
                        {" "}
                        Phase(s)
                      </Typography>
                      <Grid className={[classes.tdStyle, classes.manageInputWidth].join(' ')}>
                        <TextField
                          error={this.state.phaseError}
                          helperText={this.state.phaseError ? <div style={{ margin: '-7px' }}><span><Error />Phase(s) cannot decrease</span></div> : ''}
                          inputRef={this.myRef}
                          id="filled-number"
                          type="text"
                          variant="outlined"
                          placeholder="Phase"
                          onChange={this.handlePhaseData}
                          fullWidth
                          margin="dense"
                          defaultValue={phaseCount}
                          //value=""
                          onKeyPress={onlyAllowNumbers}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={5} className={classes.manageInputWidth}>
                      <Typography className={[classes.testLabel, classes.marginL10].join(' ')} component="subheading" gutterBottom>
                        {" "}
                        Week Format
                      </Typography>
                      <FormControl className={classes.weekFormatSelect}>
                        <Select
                          style={{
                            maxWidth: 190,
                            width: "100%",
                            border: "1px solid #dfdfdf",
                            margin: 10,
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            borderRadius: 4,
                            height: 46
                          }}
                          native
                          onChange={(e) => {
                            handleWeekSelect(e, this.props)
                          }}
                          inputProps={{ name: "age", id: "age-native-simple" }}
                          value={weekFormat}
                          error={checkWeek}
                        //defaultValue={this.state.defaultWeekFormat}
                        >
                          <option value={WEEK_FORMAT.MON_TO_SUN}>
                            {WEEK_FORMAT_LABEL.MON_TO_SUN}
                          </option>
                          <option value={WEEK_FORMAT.WEEKLY}>
                            {WEEK_FORMAT_LABEL.WEEKLY}
                          </option>
                        </Select>
                      </FormControl>
                    </Grid>

                    {checkWeek &&
                      <SaveAndProceed
                        showPopupDialog={checkWeek}
                        onSave={() => { onConfirmChangeWeekFormate(this.props) }}
                        handleCancelOnPopup={() => {
                          cancelChangeWeekFormate(this.props);
                        }}
                        dialogHeading="Update Confirmation"
                        dialogParaDetails="The dates of each phase will reset Do you really want to change the week format?"
                        saveButton="YES"
                        cancleButton="NO"
                      />
                    }
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

      </Grid>

    );
  };


  handleCreateCoursePlan = async () => {
    const { setCoursePlanStates, totalSubjectChapters, setChaptersSubject, coursePlanState, setCoursePlanResponse, showMsg, setIsTabOpen } = this.props;
    let cloneTotalSubjectChapters: any = [...totalSubjectChapters];
    let cloneCoursePlanState: any = { ...coursePlanState };
    let returnCheck = checkMinimumChapter(this.props);
    

    // if (returnCheck) {
    let returnData: any = await createCoursePlanPayload(this.props);

    if (returnData && returnData.statusCode === 200) {
      const { setTotalGoalsForComboCourse, setScheduledTestData } = this.props;
      showMsg(returnData.responseMessage, 'success');
      this.setState({ isShowCombinedPhase: true });
      setCoursePlanResponse({ coursePlanResponse: { ...returnData.responseObject.coursePlan } });
      const packageId = returnData.responseObject.coursePlan.packageId;
      const coursePlanId = returnData.responseObject.coursePlan._id;
      setGoalsDataForTest(packageId, setTotalGoalsForComboCourse);
      setScheduledTestFetchData(coursePlanId, setScheduledTestData);
      setIsTabOpen({ booleanValue: false });
      this.props.setCoursePlanDone()
    } else {
      showMsg(returnData.responseMessage, 'error');
      setCoursePlanStates({ coursePlanState: { ...cloneCoursePlanState } });
      setChaptersSubject({ totalSubjectChapters: [...cloneTotalSubjectChapters] });
    }
    //return true;
    // }
  };

  renderTargetExamDates = () => {
    console.log(this.props.courseDetailsObject, "::::::::::::::coursePart:::::::::::");
    const { courseDetailsObject } = this.props;
    let targetExamDates: any = [];
    courseDetailsObject && courseDetailsObject.forEach(({ examDates, name }: any) => {

      const dates = examDates && Boolean(examDates.length) && examDates
        .filter((targetDate: any) => targetDate && targetDate.startDate && targetDate.endDate)
        .map((targetDate: any, index: number) => {
          return `${getFormatedDate(targetDate.startDate).join(" ")} to ${getFormatedDate(targetDate.endDate).join(" ")}`
        }
        ).join(', ')


      let courseNameAndDate = `${name}`
      if (dates) {
        courseNameAndDate += ` (${dates})`
      }

      targetExamDates.push(courseNameAndDate)
    })

    return targetExamDates;
    // return this.props.courseDetailsObject && Boolean(this.props.courseDetailsObject.length) &&
    //   this.props.courseDetailsObject.map(({ examDates, name }: any) =>
    //     (<span> &nbsp;{name}-{examDates && Boolean(examDates.length) && examDates.map((targetDate: any, index: number) =>
    //       <span>{getFormatedDate(targetDate.startDate).join(" ")}-{getFormatedDate(targetDate.endDate).join(" ")}{(examDates.length) === 1 ? '' : index === examDates.length - 1 && examDates.length > 0 ? '' : ','}&nbsp;</span>
    //     )}</span>));
  }

  toggleSet=(key:string)=>{
    const {setCoursePlanStates,coursePlanState}=this.props;
    const { displaySettings } = this.state;
    const newDisplaySettings={...displaySettings};
    newDisplaySettings[key]=!newDisplaySettings[key];
    this.setState({displaySettings:newDisplaySettings})
    setCoursePlanStates({ coursePlanState: { ...coursePlanState,displaySettings:newDisplaySettings } }); 
  }

  render = () => {
    const { classes, coursePlanState = {}, phases, totalSubjectChapters, courseDetailsObject } = this.props;
    const { subjects = [], weekFormat = '', startDate = '', endDate = '' } = coursePlanState;
    const { displaySettings } = this.state;
    const { name, targetExamDate, startDate: courseStartDate, endDate: courseEndDate, examDates } = courseDetailsObject;
    let start: any = moment(courseStartDate).format('DD');
    let end: any = moment(courseEndDate).format('DD-MMM-YYYY');
    let totalChapters = 0;
    subjects.forEach((item: any) => {
      totalChapters += item.chapterCount;
    });
    const labels: string[] = ["Phase", "Week", "Chapter", "Concept"]
    //console.log(this.state.isShowCombinedPhase, ':::::::::::state:::::');
    const checkCountDistribution = checkTotalChapterDistributed(this.props);
    const checkSamePhaseName = checkDuplicatePhaseName(this.props);
    const checkDateData = checkPhaseData(this.props);

    const validateData = () => {
      if (checkDateData === true && checkCountDistribution === true && checkSamePhaseName === false) {
        this.props.setCoursePlanValid(true)
        return true
      }
      else {
        this.props.setCoursePlanValid(false)
        return false
      }
    }
    const checkValidation = validateData();

    

    return this.state.loading ? <MyPatLocalLoader /> : <>

      <>
        <>
          {this.state.isShowCombinedPhase && this.returnCombinedPhases()}
          {!this.state.isShowCombinedPhase && (
            <>
              {this.renderCourseContainer()}
              <Grid>
                <Table
                  className={classes.tableContainer}
                  aria-label="customized table"
                  style={{ minWidth: '1020px' }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.testLabel} style={{ minWidth: '200px' }}>Phases Name</TableCell>
                      {/* <TableCell className={[classes.testLabel, classes.scrollHide].join(' ')}style={{display: "flex", justifyContent: 'flex-start',
              width: '450px'}}> */}
                      {this.generateHeader(subjects)}
                      {/* </TableCell> */}
                      <TableCell className={classes.testLabel} style={{ minWidth: '200px' }}>
                        Start Date
                      </TableCell>
                      <TableCell className={classes.testLabel} style={{ minWidth: '200px' }}>End Date</TableCell>
                      <TableCell className={classes.manageTooltip} style={{ padding: '0 20px', width: '50px' }}>
                        <Tooltip title="Is Revision?" placement="top">
                          <img src="/assets/svg/bookmarkIcon.svg" alt="Revision" />
                        </Tooltip>
                      </TableCell>
                      <TableCell className={classes.phaseToggle}>                        
                        <span>
                          Activate Phase
                          <span className="infoContainer"><CustomInfoIcon
                            hideCloseIconInPopup={true}
                            infoDialogContentType="Add alternate answer"
                            isInfoIcon={true}
                            isRightArrow={false}
                            isCenterArrow={true}
                            knowMoreAbout={false}
                            dialogTitle={
                              <>
                                <span className="text-initial">Activate Phase on Glorifire</span>
                              </>
                            }
                            dialogPara=""
                            details="Click Here"
                            isHidePhase={true}
                            htmlElement= {
                              <>
                                <p className="dialog-para-text">The activated phases will be visible to both students and teachers on their respective Glorifire and Glorifire Stakeholder platform.  By default, any phase with a start date beyond the current academic year will be automatically deactivated.</p>
                              </>
                            } /></span>
                        </span>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{this.renderPhaseRow()}</TableBody>
                </Table>

                <Grid container justify="flex-end" className={classes.addMoreContainer}>
                  <Grid item>
                    <Button color="primary" className={classes.weight600} onClick={() => this.addNewPhase()}>
                      <AddIcon /> Add Phase
                    </Button>
                  </Grid>

                </Grid>
                <Grid className={classes.blockContainer}>
                  <Typography className={classes.blockTitle}>Show the following in Course Plan</Typography>
                  <Typography>
                  {labels.map((item) => {
                    return (<FormControlLabel
                      className={classes.updateLabel}
                      control={
                        <Switch
                          classes={{
                            root: classes.swithMain,
                            icon: classes.switchIcon,
                            bar: classes.switchBar,
                            iconChecked: classes.IscheckedSwitch,
                            checked: classes.checkedSwitch,
                          }}
                          color="primary"
                          checked={
                            displaySettings["show" + item + "s"]
                          }
                          onChange={() =>
                            this.toggleSet("show" + item + "s")
                          }
                          disabled={item=='Phase'}
                        />
                      }
                      label={item}
                      labelPlacement="start"
                    />)
                  }
                  )}
                </Typography>
                </Grid>  
              </Grid>

              <Grid className={classes.phaseFooterFixed}>
                <DialogLarge
                  headerTitle=""
                  isShowHeader={false}
                  isFooter
                  footerCTAName="Create Course Plan"
                  onJobDone={() => this.handleCreateCoursePlan()}
                  isJobDoneDisabled={!checkValidation}
                  htmlElements={
                    <Grid className={classes.examContainer}>
                      <Typography>
                        <img src="/assets/svg/goalNav1.svg" color="primary" />
                        &nbsp;Target Exam Date
                      </Typography>
                      <Typography className={classes.examDate}>
                        <MyPATTruncateText
                          data={this.renderTargetExamDates()}
                          truncateLength={1000}
                          displayCount={1}
                        />
                      </Typography>
                    </Grid>
                  }
                />
              </Grid>
              {/* <Grid className={classes.phaseFooterFixed}>
                  <DialogLarge
                    headerTitle=""
                    isShowHeader={false}
                    isFooter
                    footerCTAName="Create Course Plan"
                    onJobDone={() => this.handleCreateCoursePlan()}
                    isJobDoneDisabled={!checkCountDistribution}
                    htmlElements={
                      <Grid className={classes.examContainer}>
                        <Typography>
                          <img src="/assets/svg/goalNav1.svg" color="primary" />
              &nbsp;Target Exam Date
              </Typography>
                        <Typography className={classes.examDate}>
                          &nbsp;{name}-{start}-{end}
                        </Typography>
                      </Grid>
                    }
                  />
                  <Button variant="contained" disabled={!checkCountDistribution} color="primary" onClick={() => {this.handleCreateCoursePlan()}}> Create Course Plan</Button>
                </Grid> */}
            </>
          )}
      
        </>
        
      </>

    </>
  };
}

const mapStateToProps = (state: any) => ({
  coursePlanState: state.createCoursePlanStates.coursePlanState,
  phases: state.createCoursePlanStates.phases,
  addedChapterCount: state.createCoursePlanStates.addedChapterCount,
  courseSyllabus: state.createCoursePlanStates.courseSyllabus,
  totalSubjectChapters: state.createCoursePlanStates.totalSubjectChapters,
  coursePlanResponse: state.createCoursePlanStates.coursePlanResponse,
  getPackageByIdData: _.get(
    state,
    'courseMangementData.contentManagementData.packageByIdData.packageData',
    {}
  ),
  mergedComboCourse: _.get(state, 'courseMangementData.contentManagementData.mergedComboCourse', {}),
  isTabOpen: _.get(state, 'courseMangementData.contentManagementData.isTabOpen', false),
  courseDetailsObject: state.createCoursePlanStates.courseDetailsObject,
  phaseCount: state.createCoursePlanStates.phaseCount,
  treeData: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),
  checkWeek: state.createCoursePlanStates.checkWeek,
  // disabledDatesList: state.createCoursePlanStates.disabledDatesList,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setPhaseData: createCoursePlanStatesAction.setPhaseData,
      setchapterCount: createCoursePlanStatesAction.setchapterCount,
      setCourseSyllabus: createCoursePlanStatesAction.setCourseSyllabus,
      setCoursePlanStates: createCoursePlanStatesAction.setCoursePlanStates,
      setChaptersSubject: createCoursePlanStatesAction.setChaptersSubject,
      setCoursePlanResponse: createCoursePlanStatesAction.setCoursePlanResponse,
      setTotalGoalsForComboCourse: contentManagementAction.setTotalGoalsForComboCourse,
      setScheduledTestData: contentManagementAction.setScheduledTestData,
      showMsg: showMsg,
      setCoursePlanDone: contentManagementAction.setCoursePlanDone,
      setCoursePlanValid: contentManagementAction.setCoursePlanValid,
      setIsTabOpen: contentManagementAction.setIsTabOpen,
      setCourseDetailsObject: createCoursePlanStatesAction.setCourseDetailsObject,
      setPhaseCount: createCoursePlanStatesAction.setPhaseCount,
      setCheckWeek: createCoursePlanStatesAction.setCheckWeek,
      // setPreviousPhaseData: createCoursePlanStatesAction.setPreviousPhaseData,

    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(createCoursePlanStyles)(CreateCoursePlanContainer));